import { ParseError } from '@/shared/api/generated/.kubb/standardSchema'

const formatPath = (path: ReadonlyArray<PropertyKey | { readonly key: PropertyKey }>) =>
  path
    .map((part) => (typeof part === 'object' ? part.key : part))
    .map(String)
    .join('.')

export const formatParseErrorIssues = (error: unknown): string[] => {
  if (!(error instanceof ParseError)) {
    return []
  }

  return error.issues.map((issue) => {
    const path = issue.path ? formatPath(issue.path) : ''
    const message = issue.message ?? 'Invalid value'
    return path ? `${path}: ${message}` : message
  })
}
